import React, { useState, useEffect } from 'react';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import { database, ref as dbRef, get, set, remove, push } from '../../firebase';
import { FaPlus, FaEdit, FaTrash, FaTimes, FaMapMarkerAlt, FaStar } from 'react-icons/fa';

const AdminBranch = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  
  const [formData, setFormData] = useState({
    englishName: '',
    marathiName: '',
    englishAddress: '',
    marathiAddress: '',
    city: '',
    phone: '',
    mapLink: '',
    isHeadOffice: false
  });

  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed);

  useEffect(() => {
    loadBranches();
  }, []);

  const loadBranches = async () => {
    setLoading(true);
    try {
      const branchesRef = dbRef(database, 'shivpratapmultistate/branches');
      const snapshot = await get(branchesRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setBranches(list);
      } else {
        setBranches([]);
      }
    } catch (error) {
      console.error('Error loading branches:', error);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editingId) {
        const branchRef = dbRef(database, `shivpratapmultistate/branches/${editingId}`);
        await set(branchRef, formData);
      } else {
        const branchesRef = dbRef(database, 'shivpratapmultistate/branches');
        const newRef = push(branchesRef);
        await set(newRef, formData);
      }
      setShowModal(false);
      loadBranches();
      resetForm();
    } catch (error) {
      console.error('Error saving branch:', error);
    }
    setLoading(false);
  };

  const handleEdit = (branch) => {
    setFormData({
      englishName: branch.englishName || branch.name || '',
      marathiName: branch.marathiName || branch.name || '',
      englishAddress: branch.englishAddress || branch.address || '',
      marathiAddress: branch.marathiAddress || branch.addressMr || '',
      city: branch.city || '',
      phone: branch.phone || '',
      mapLink: branch.mapLink || '',
      isHeadOffice: branch.isHeadOffice || false
    });
    setEditingId(branch.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this branch?')) {
      setLoading(true);
      try {
        const branchRef = dbRef(database, `shivpratapmultistate/branches/${id}`);
        await remove(branchRef);
        loadBranches();
      } catch (error) {
        console.error('Error deleting branch:', error);
      }
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      englishName: '',
      marathiName: '',
      englishAddress: '',
      marathiAddress: '',
      city: '',
      phone: '',
      mapLink: '',
      isHeadOffice: false
    });
    setEditingId(null);
  };

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const migrateOldData = async () => {
    if (window.confirm('This will load default hardcoded branches into database. Are you sure?')) {
      setLoading(true);
      try {
        const headOffice = {
          englishName: 'Main Office (Vita)',
          marathiName: 'मुख्य कार्यालय (विटा)',
          city: 'vita',
          englishAddress: 'Shivpratap Gold Tower, Power House Road, 2nd Floor, Vita.',
          marathiAddress: 'शिवप्रताप गोल्ड टॉवर,पॉवर हाऊस रोड, दुसरा मजला,विटा.',
          mapLink: 'https://maps.app.goo.gl/NZ2BXT9Zdtv7J9SS8',
          phone: '02347-276399',
          isHeadOffice: true
        };

        const defaultBranches = [
          { englishName: 'Main Branch, Vita', marathiName: 'मुख्य शाखा, विटा', city: 'vita', englishAddress: 'Shivpratap Gold Tower, Power House Road, 1st Floor, Vita.', marathiAddress: 'शिवप्रताप गोल्ड टॉवर,पॉवर हाऊस रोड, पहिला मजला,विटा.', phone: '02347-276399', mapLink: 'https://maps.app.goo.gl/NZ2BXT9Zdtv7J9SS8' },
          { englishName: 'Choundeshwari Temple Branch, Vita', marathiName: 'चौंडेश्वरी मंदिर शाखा, विटा', city: 'vita', englishAddress: 'Near Bhairavnath Theater, Lengare Road, Vita.', marathiAddress: 'भैरवनाथ थिएटर जवळ, लेंगरे रोड, विटा.', phone: '02347-276371', mapLink: 'https://maps.app.goo.gl/666gNKgq37zcwL2AA' },
          { englishName: 'Sangli Branch', marathiName: 'सांगली शाखा', city: 'sangli', englishAddress: 'New Saraf Katta, Sanika Bhavan, Opposite Tanvade Book Depot, Sangli.', marathiAddress: 'नवीन सराफ कट्टा, सानिका भवन, तानवडे बुक डेपो समोर, सांगली.', phone: '0233-2327399', mapLink: 'https://maps.app.goo.gl/spuQY6Snbs4xgvZ77' },
          { englishName: 'Khanapur Branch', marathiName: 'खानापूर शाखा', city: 'khanapur', englishAddress: 'Opposite ST Stand, Near Satish Dresses, Shivparvati Building, Khanapur.', marathiAddress: 'एसटी स्टँड समोर, सतीश ड्रेसेस जवळ, शिवपार्वती बिल्डिंग खानापूर.', phone: '02347-295416', mapLink: 'https://maps.app.goo.gl/YvhvyUkBm1LpTT7s9?g_st=aw' },
          { englishName: 'Tasgaon Branch', marathiName: 'तासगाव शाखा', city: 'tasgaon', englishAddress: 'Chhatrapati Shivaji Maharaj Chowk, near Vitthal Mandir, Sangli Road, Tasgaon.', marathiAddress: 'छत्रपती शिवाजी महाराज चौक, विठ्ठल मंदिर जवळ ,साांगली रोड, तासगाव.', phone: '02346-240599', mapLink: 'https://maps.app.goo.gl/VnCccvJg2Uur6mTL6?g_st=awb' },
          { englishName: 'Atpadi Branch', marathiName: 'आटपाडी शाखा', city: 'atpadi', englishAddress: 'Opposite Atpadi College, Dighanchi Road, Atpadi.', marathiAddress: 'आटपाडी कॉलेज समोर, दिघंची रोड, आटपाडी.', phone: '02343-220399', mapLink: 'https://maps.app.goo.gl/mbLBb3E7spdCjfaL8' },
          { englishName: 'Mayani Branch', marathiName: 'मायणी शाखा', city: 'mayani', englishAddress: 'Opposite S.T. Stand, Main Road, Mayani.', marathiAddress: 'एस.टी. स्टँड समोर, मेन रोड, मायणी.', phone: '02161-270999', mapLink: 'https://maps.app.goo.gl/CEcAkow8hv8wWX4A6' },
          { englishName: 'Jat Branch', marathiName: 'जत शाखा', city: 'jat', englishAddress: 'Near LIC Office, Umrani Road, Jat.', marathiAddress: 'एल.आय.सी. ऑफिस जवळ, उमराणी रोड, जत.', phone: '02344-248999', mapLink: 'https://maps.app.goo.gl/AVSpEVrD2JY3RUBh7' },
          { englishName: 'Kavathe Mahankal Branch', marathiName: 'कवठे महांकाळ शाखा', city: 'kavathe_mahankal', englishAddress: 'Chhatrapati Shivaji Maharaj Chowk, Sangli District Central Bank Road, Kavathe Mahankal.', marathiAddress: 'छत्रपती शिवाजी महाराज चौक, सांगली जिल्हा मध्यवर्ती बँक रस्ता, कवठे महांकाळ.', phone: '02341-223999', mapLink: 'https://maps.app.goo.gl/suPoXrcdeh1jqq3Q7' },
          { englishName: 'Miraj Branch', marathiName: 'मिरज शाखा', city: 'miraj', englishAddress: 'Satar Maker Galli, Shaniwar Peth, Miraj', marathiAddress: 'आण्णा बुवा महाराज मठासमोर,सत्तार मेकर गल्ली, शनिवार पेठ,मिरज.', phone: '0233-2220299', mapLink: '' },
          { englishName: 'Karad Branch', marathiName: 'कराड शाखा', city: 'karad', englishAddress: 'Azad Chowk, Patil & Company Building, Somwar Peth, Karad', marathiAddress: 'आझाद चौक, पाटील अँड कंपनी बिल्डिंग, सोमवार पेठ, कराड', phone: '02364-245678', mapLink: '' },
          { englishName: 'Islampur Branch', marathiName: 'ईश्वरपूर शाखा', city: 'islampur', englishAddress: 'Kala Maruti Mandir, Kala Maruti Chowk, Islampur.', marathiAddress: 'काळा मारुती मंदिर काळा मारुती चौक, ईश्वरपूर.', phone: '8960050042', mapLink: 'https://maps.app.goo.gl/HdKmkpiHGU2rsuYL9' },
          { englishName: 'Ichalkaranji Branch', marathiName: 'इचलकरंजी शाखा', city: 'ichalkaranji', englishAddress: 'Old Municipal Council Road, Beside Magdum, Near Girnar Apartment, Ichalkaranji.', marathiAddress: 'जुनी महानगरपालिका रोड, मगदुम शेजारी, गिरनार अपार्टमेंट शेजारी,इचलकरंजी.', phone: '7460050051', mapLink: 'https://maps.app.goo.gl/MrrLCgnnLCZP9BMRA' },
          { englishName: 'Athani Branch', marathiName: 'अथणी शाखा', city: 'athani', englishAddress: 'Gotkhindi Galli, Bhaji Market, Athani.', marathiAddress: 'गोटखिंडी गल्ली भाजी मार्केट, अथणी.', phone: '7460050052', mapLink: 'https://maps.app.goo.gl/78VtZ6erRkoyZy3M6' },
          { englishName: 'Bhalvani Branch', marathiName: 'भाळवणी शाखा', city: 'bhalvani', englishAddress: 'Main Road, Mulla Wada, Bhalvani.', marathiAddress: 'मेन रोड ,मुल्ला वाडा ,भाळवणी.', phone: '8960050043', mapLink: 'https://maps.app.goo.gl/3Tm4tAFwrL5q6Z2f7' },
          { englishName: 'Shirala Branch', marathiName: 'शिराळा शाखा', city: 'shirala', englishAddress: 'ST Stand Road, Opposite SBI, Shirala.', marathiAddress: 'एस टी स्टँड रोड, स्टेट बँक ऑफ इंडिया समोर, शिराळा.', phone: '02345-245678', mapLink: 'https://maps.app.goo.gl/MnnTF3WfWXhYtPbe7' },
          { englishName: 'Peth Vadgaon Branch', marathiName: 'पेठ वडगाव शाखा', city: 'peth_vadgaon', englishAddress: 'Guruganga Apartment, Opposite Momin Hospital, Padma Road, Peth Vadgaon.', marathiAddress: 'गुरुगंगा अपार्टमेंट , मोमीन हॉस्पिटल समोर,पद्मा रोड, पेठ वडगाव.', phone: '02347-245678', mapLink: 'https://maps.app.goo.gl/Qz9Ad8UNyJzSNfNt5' },
          { englishName: 'Ashta Branch', marathiName: 'आष्टा शाखा', city: 'ashta', englishAddress: 'Opposite Sagar Jewellers, Pawar City Center, Main Road, Ashta.', marathiAddress: 'सागर ज्वेलसा समोर,पवार सिटी सेंटर, मेन रोड आष्टा.', phone: '+91 63690 93632', mapLink: '' },
          { englishName: 'Alsund Branch', marathiName: 'आळसंद शाखा', city: 'alsund', englishAddress: 'Opposite Dombe Medical, Vita-Kundal Road, Alsund.', marathiAddress: 'डोंबे मेडिकल समोर, विटा-कुंडल रोड,आळसंद.', phone: '02188-245678', mapLink: 'https://maps.app.goo.gl/jUdc1Fojvo827xha8' },
          { englishName: 'Vashi Branch', marathiName: 'वाशी शाखा', city: 'vashi', englishAddress: 'Gavdevi Mandir Javal, Sector 14, Vashi Koparkhairane Road, Vashi – 400703', marathiAddress: 'गावदेवी मंदिर जवळ, सेक्टर १४, वाशी कोपरखैरणे रोड, वाशी – ४००७०३', phone: '022-27894567', mapLink: '' },
          { englishName: 'Koparkhairane Branch', marathiName: 'कोपरखैरणे शाखा', city: 'koparkhairane', englishAddress: 'Swagat Chamber, Plot No. 19, Opposite North Point School of Village, Koparkhairane.', marathiAddress: 'स्वागत चेंबर , प्लॉट न १९, नॉर्थ पॉईंट स्कूल ऑफ व्हीलेज समोर , कोपरखैरणे', phone: '022-27784567', mapLink: 'https://maps.app.goo.gl/mxZxyrSN5vE7rtBv5' },
          { englishName: 'Kalamboli Branch', marathiName: 'कळंबोली शाखा', city: 'kalamboli', englishAddress: 'Shop No. 13, Platinum Experio, Plot No. 82, Sector 17, Roadpali, Kalamboli.', marathiAddress: 'शॉप नं. १३, प्लॅटिनियम एक्सपेरीओ,प्लॉट नं. ८२ सेक्टर १७, रोडपाली, कळंबोली.', phone: '02192-245678', mapLink: 'https://maps.app.goo.gl/G9ayLFUjuQWCiJDH6' },
          { englishName: 'Vishrantwadi, Pune Branch', marathiName: 'विश्रांतवाडी, पुणे शाखा', city: 'pune', englishAddress: 'Shop No. 74, Mahalakshmi Vihar, Alandi Road, Vishrantwadi (Pune).', marathiAddress: 'शॉप न- 74, महालक्ष्मी विहार, आळंदी रोड , विश्रांतवाडी.( पुणे)', phone: '020-24567890', mapLink: 'https://maps.app.goo.gl/x8b4Mcitbb9sGLEH8' }
        ];
        
        const branchesRef = dbRef(database, 'shivpratapmultistate/branches');
        await set(push(branchesRef), headOffice);
        for (const branch of defaultBranches) {
          const newRef = push(branchesRef);
          await set(newRef, branch);
        }
        loadBranches();
      } catch (error) {
        console.error('Error migrating data:', error);
      }
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50">
      <AdminSidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <AdminNavbar sidebarCollapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      
      <div className={`transition-all duration-300 ease-in-out pt-20 ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
        <div className="p-4 lg:p-8 max-w-7xl mx-auto">
          
          <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold text-gray-800">Branch Locations</h1>
              <p className="text-gray-600">Manage all bank branches</p>
            </div>
            <div className="flex gap-2">
              {branches.length === 0 && (
                <button onClick={migrateOldData} className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors">
                  Load Default Data
                </button>
              )}
              <button onClick={openAddModal} className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                <FaPlus /> Add Branch
              </button>
            </div>
          </div>

          {loading && !showModal ? (
            <div className="text-center py-10 text-gray-500">Loading branches...</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
              {branches.map(branch => (
                <div key={branch.id} className="bg-white rounded-xl shadow p-5 border border-gray-100 flex flex-col justify-between relative overflow-hidden">
                  {branch.isHeadOffice && (
                    <div className="absolute top-0 right-0 bg-yellow-400 text-white px-3 py-1 text-xs font-bold rounded-bl-lg shadow flex items-center gap-1">
                      <FaStar /> Head Office
                    </div>
                  )}
                  <div className={branch.isHeadOffice ? "mt-3" : ""}>
                    <h3 className="font-bold text-lg text-gray-800 mb-1">{branch.englishName || branch.name}</h3>
                    <p className="text-sm text-gray-500 mb-3">{branch.marathiName || branch.name}</p>
                    <div className="flex items-start gap-2 text-gray-600 text-sm mb-2">
                      <FaMapMarkerAlt className="mt-1 flex-shrink-0 text-red-500" />
                      <span>{branch.englishAddress || branch.address}</span>
                    </div>
                  </div>
                  <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
                    <button onClick={() => handleEdit(branch)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                      <FaEdit />
                    </button>
                    <button onClick={() => handleDelete(branch.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
              {branches.length === 0 && (
                <div className="col-span-full text-center py-12 bg-white rounded-xl border border-gray-100 text-gray-500">
                  No branches found. Click 'Add Branch' or 'Load Default Data' to get started.
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
              <h2 className="text-xl font-bold text-gray-800">{editingId ? 'Edit Branch' : 'Add New Branch'}</h2>
              <button onClick={() => setShowModal(false)} className="text-gray-500 hover:text-gray-700">
                <FaTimes size={24} />
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div className="flex items-center gap-2 mb-2 p-3 bg-blue-50 rounded-lg border border-blue-100">
                <input 
                  type="checkbox" 
                  id="isHeadOffice" 
                  name="isHeadOffice" 
                  checked={formData.isHeadOffice} 
                  onChange={handleInputChange} 
                  className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="isHeadOffice" className="text-sm font-medium text-blue-900">This is the Head Office</label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">English Name</label>
                  <input type="text" name="englishName" value={formData.englishName} onChange={handleInputChange} required className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Marathi Name</label>
                  <input type="text" name="marathiName" value={formData.marathiName} onChange={handleInputChange} required className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">English Address</label>
                  <textarea name="englishAddress" value={formData.englishAddress} onChange={handleInputChange} required rows="2" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Marathi Address</label>
                  <textarea name="marathiAddress" value={formData.marathiAddress} onChange={handleInputChange} required rows="2" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"></textarea>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">City Key (e.g. vita, pune)</label>
                  <input type="text" name="city" value={formData.city} onChange={handleInputChange} required className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                  <input type="text" name="phone" value={formData.phone} onChange={handleInputChange} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Google Maps Link</label>
                <input type="url" name="mapLink" value={formData.mapLink} onChange={handleInputChange} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>

              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200">
                  Cancel
                </button>
                <button type="submit" disabled={loading} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {loading ? 'Saving...' : 'Save Branch'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminBranch;
